import { Stack } from '@mui/material';
import { FC, KeyboardEvent, ReactNode } from 'react';

import { Radio, theme, Typography } from '@/shared/design-system';

import { NewContactCardContainer } from './styled';

interface NewContactCardProps {
  radioValue: string;
  icon?: ReactNode;
  disabledReason?: string;
  onDisabledActivate?: () => void;
}

export const NewContactCard: FC<NewContactCardProps> = ({
  radioValue,
  icon,
  disabledReason,
  onDisabledActivate,
}) => {
  const isDisabled = Boolean(disabledReason);

  return (
    <NewContactCardContainer
      isDisabled={isDisabled}
      {...(isDisabled && {
        role: 'button',
        tabIndex: 0,
        'aria-disabled': true,
        'aria-label': `New contact, unavailable. ${disabledReason}`,
        onClick: onDisabledActivate,
        onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onDisabledActivate?.();
          }
        },
      })}
    >
      <Radio value={radioValue} size="md" disabled={isDisabled} />
      {icon}
      <Stack flexDirection="column" minWidth={0}>
        <Typography variant="body2" fontWeight={500}>
          New contact
        </Typography>
        <Typography variant="body3" color={theme.colors.text.secondary}>
          Import as a new person — no existing record will be updated
        </Typography>
      </Stack>
    </NewContactCardContainer>
  );
};
